import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=01938d6f&scoped=true"
import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=01938d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01938d6f",
  null
  
)

export default component.exports